'use client';

import { useState } from 'react';
import { useParams, useRouter } from 'next/navigation';
import { AlertCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import Link from 'next/link';
import { VoiceAgentModal, type MomentoVoice } from '@/components/livekit/VoiceAgentModal';

const VOICES: Record<string, MomentoVoice> = {
  kiefer: {
    id: 'Dennis',
    name: 'Kiefer',
    avatar: '/voices/kiefer.png',
    description: "Let's capture your story",
  },
  tessa: {
    id: 'Ashley',
    name: 'Tessa',
    avatar: '/voices/tessa.png',
    description: 'Ready to share something great?',
  },
};

export default function TryConversationPage() {
  const params = useParams();
  const router = useRouter();
  const voiceKey = (params.voice as string)?.toLowerCase();
  const voice = VOICES[voiceKey];
  const [isOpen, setIsOpen] = useState(true);

  if (!voice) {
    return (
      <div className="min-h-screen flex items-center justify-center p-4">
        <div className="text-center">
          <AlertCircle className="w-12 h-12 text-muted-foreground mx-auto mb-4" />
          <h1 className="text-2xl font-bold mb-2">Guide not found</h1>
          <p className="text-muted-foreground mb-6">
            Try talking to Kiefer or Tessa instead.
          </p>
          <div className="flex gap-3 justify-center">
            <Link href="/try/kiefer">
              <Button>Talk to Kiefer</Button>
            </Link>
            <Link href="/try/tessa">
              <Button variant="outline">Talk to Tessa</Button>
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-gradient-to-br from-gray-50 via-purple-50/30 to-pink-50/30 dark:from-gray-950 dark:via-purple-950/10 dark:to-pink-950/10">
      <VoiceAgentModal
        open={isOpen}
        onOpenChange={(open) => {
          setIsOpen(open);
          if (!open) router.push('/');
        }}
        voice={voice}
      />
    </div>
  );
}
